var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getText } from '@storebrand-digital/fms-translations';
import Modal from '@storeblocks/modal';
import { SystemIcon } from '@storeblocks/icon';
import Attachments from '../../../components/Attachments';
import { AllAttachmentsWrap, NoAttachmentsWrap, Title } from './styled';
function AllAttachments() {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var records = useSelector(function (state) { return state.messageThread; }).records;
    var emptyFilteredTasks = {
        tasksAdvisor: [],
        tasksCustomer: [],
    };
    var _b = useMemo(function () {
        if (!open || records === undefined) {
            return emptyFilteredTasks;
        }
        return records
            .filter(function (record) { return record.files.length > 0; })
            .reduce(function (message, currentMessage) {
            var filteredTasks = currentMessage.isFromAdvisor
                ? { tasksAdvisor: __spreadArray(__spreadArray([], message.tasksAdvisor, true), [currentMessage], false) }
                : { tasksCustomer: __spreadArray(__spreadArray([], message.tasksCustomer, true), [currentMessage], false) };
            return __assign(__assign({}, message), filteredTasks);
        }, emptyFilteredTasks);
    }, [open, records]), tasksAdvisor = _b.tasksAdvisor, tasksCustomer = _b.tasksCustomer;
    function renderAttachments() {
        if (tasksAdvisor.length === 0 && tasksCustomer.length === 0) {
            return React.createElement("div", null, getText('chat.attachments.empty'));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Title, null, getText('chat.attachments.advisor.title')),
            tasksAdvisor.length === 0 ? (React.createElement(NoAttachmentsWrap, null, getText('chat.attachments.advisor.empty'))) : (tasksAdvisor.map(function (task) { return (React.createElement(Attachments, { key: task.id, attachments: task.files, taskId: task.id, right: false, date: task.createdDate })); })),
            React.createElement(Title, { marginTop: "32px" }, getText('chat.attachments.customer.title')),
            tasksCustomer.length === 0 ? (React.createElement(NoAttachmentsWrap, null, getText('chat.attachments.customer.empty'))) : (tasksCustomer.map(function (task) { return (React.createElement(Attachments, { key: task.id, attachments: task.files, taskId: task.id, right: true, date: task.createdDate })); }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AllAttachmentsWrap, { onClick: function () { return setOpen(true); } },
            React.createElement("p", { className: "font-weight-500" }, getText('chat.attachments.label')),
            React.createElement(SystemIcon, { name: "attachment", size: 16, mr: "16px" })),
        React.createElement(Modal, { open: open, onClose: function () { return setOpen(false); }, title: getText('chat.attachments.label'), trigger: undefined, content: renderAttachments() })));
}
export default AllAttachments;
